import { useState } from "react";
import { Alert, Card, Stack, Text } from "@/components/ui";
import { useRolesAdmin } from "../hooks/use-roles-admin";
import { RolesHeader } from "./RolesHeader";
import { RolCrearForm } from "./RolCrearForm";
import { RolesTable } from "./RolesTable";

/**
 * Página de gestión de roles (`/admin/roles`). CRUD sobre los roles de Identity.
 * Los 7 roles del sistema están protegidos (no se renombran ni eliminan); los
 * personalizados son etiquetas asignables a usuarios que NO otorgan permisos por
 * sí solas (requieren cablearse en el código del backend).
 */
export function AdminRolesPage() {
  const [modoCrear, setModoCrear] = useState(false);
  const { data: roles } = useRolesAdmin();

  const personalizados = roles.filter((r) => !r.esSistema).length;

  return (
    <div className="mx-auto max-w-7xl px-4 py-8 md:px-6">
      <RolesHeader
        total={roles.length}
        personalizados={personalizados}
        modoCrear={modoCrear}
        onIniciarCrear={() => setModoCrear(true)}
      />
      <Stack gap="md">
        <Alert variant="info" title="Cómo funcionan los roles y sus permisos">
          <Text size="sm">
            Cada rol otorga los <b>permisos</b> que tenga asignados (columna «Permisos»). Los roles
            del sistema (con candado) traen un conjunto fijo de permisos que refleja el acceso base
            del portal y no se pueden renombrar ni eliminar. En los roles <b>personalizados</b> tú
            decides qué permisos otorgan. Un cambio de permisos aplica al instante en el servidor; en
            la sesión de cada usuario, tras su próximo inicio de sesión.
          </Text>
        </Alert>
        {modoCrear ? <RolCrearForm onSalir={() => setModoCrear(false)} /> : null}
        <Card padding="lg">
          <RolesTable roles={roles} />
        </Card>
      </Stack>
    </div>
  );
}
